import { colors, getSpacing } from '@cabonline/ui-shared';
import styled from '@emotion/styled';
import React, { useId } from 'react';

import { Button } from '../../button';
import { ButtonRow } from '../../form/button-row';
import { Text } from '../../text';
import { Modal } from '../modal';
import { StyledDangerButton } from '../styled-danger-button';

const StyledContent = styled.div`
  padding: ${getSpacing('l')};
`;

export interface DeleteConfirmModalProps {
  isOpen: boolean;
  title: string;
  description: string | React.ReactNode;
  errorMessage?: string | null;
  isSubmitting?: boolean;
  cancelLabel: string;
  confirmLabel: string;
  /** Renders the confirm button with danger (red) styling — default true */
  destructive?: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  title,
  description,
  errorMessage,
  isSubmitting = false,
  cancelLabel,
  confirmLabel,
  destructive = true,
  onClose,
  onConfirm,
}) => {
  const descriptionId = useId();
  const ConfirmButton = destructive ? StyledDangerButton : Button;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      role="alertdialog"
      describedBy={descriptionId}
    >
      <StyledContent>
        <Text id={descriptionId} marginBottom="l">
          {description}
        </Text>
        {errorMessage && <Text color={colors.red} marginBottom="l">{errorMessage}</Text>}
        <ButtonRow>
          <Button
            variant="tertiary"
            label={cancelLabel}
            onClick={onClose}
            disabled={isSubmitting}
          />
          <ConfirmButton
            label={confirmLabel}
            onClick={onConfirm}
            disabled={isSubmitting}
            testID="confirm-delete-button"
            aria-busy={isSubmitting}
          />
        </ButtonRow>
      </StyledContent>
    </Modal>
  );
};
